import React from 'react'
import {ProgressOverlay} from '@bbnpm/bb-ui-framework';

export default class Progress extends React.Component {

    render = () => {
        return (<ProgressOverlay active={true} label='Submitting...'/>)
    }
}
